import io from 'socket.io-client';
import { CustomAppLayout } from '../layout';
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { ReactNode, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useRouter } from '../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../context/GlobalStateContext';




import { Alert, Box, Button, Container, Divider, ExpandableSection, FlashbarProps, Form, FormField, KeyValuePairs, Link, SegmentedControl, SpaceBetween, Spinner, Tabs } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiArrowCollapseVertical, mdiCctv, mdiCheckboxMultipleBlankOutline, mdiCloudOffOutline, mdiPirate, mdiThermometer, mdiWeatherSunsetDown, mdiWeatherWindy } from '@mdi/js';
import Icon from '@mdi/react';
//import CompassGauge from '../../../components/charts/RadialGauge';
import { tz } from '@date-fns/tz';
import { addDays, addYears, format, getMonth, isAfter, isValid, parse, subMonths } from 'date-fns';
import { es } from 'date-fns/locale/es';
import GaugePressure from '../../../components/charts/GaugePresure';
import GaugeTemp from '../../../components/charts/GaugeTemp';
import GaugeWind from '../../../components/charts/GaugeWind';
import Confirm from '../../../components/extras/Confirm';
import PopOverContact from '../../../components/extras/PopOverContact';
import Spacer from '../../../components/extras/Spacer';
import StepsCheck from '../../../components/extras/StepsCheck';
import { fetchWithWatch } from '../../../hooks/fetchWithWatch';
import { ItemCheck, ItemPoll, ItemsGroups, ItemsMovement, ItemUser } from '../../../resources/types';
import { addNotification, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, getUser, isMobileDevice, setData, setLoading, setNotifications, storeJWT } from '../../commons/functions';


interface AmbientData {
    windspeedmph: number;
    winddir: number;
    [key: string]: any; // Allows for other fields like temp, humidity, etc.
}

const pageSize = 20;
interface Access {
    idAcceso: number;
    isActive: number;
    isMantAcceso: number;
    relay: number;
    acceso: string;
    isOnline: number;
    manualOpenEnable: number;
    idSector: number;
    sector: string;
    label: string;
    id: string;
    description?: string
    disabled?: boolean;
}
interface MyBoardItemData {
    title: string;
    description?: string;
    content: React.ReactNode;
    footer?: React.ReactNode;
    actions?: React.ReactNode;
}

interface Item {
    id: string;
    rowSpan: number;
    columnSpan: number;
    minRowSpan?: number;
    minColumnSpan?: number;
    data: {
        title: string;
        content: string | ReactNode;
        settings?: string | ReactNode;
        footer?: React.ReactNode;

    };
}
type LogItem = { idLog: number; fecha: string; hora: string; status: string; log: string; user: string; objTime: string; };
interface Sector { idSector: number; sector: string; }

export const HomePage = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName } = useGlobalState();
    //const storeAdmin = useStoreAdmin();

    const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const [shift, setShift] = useState<any[]>([]);
    const [shiftNew, setShiftNew] = useState<any[]>([]);

    const [fuelAVGASInternal, setFuelAVGASInternal] = React.useState(0)
    const [fuelAVGASExternal, setFuelAVGASExternal] = React.useState(0)
    const [counters, setCounters] = useState<any>()

    const [fuelJP1Internal, setFuelJP1Internal] = React.useState(0)
    const [fuelJP1External, setFuelJP1External] = React.useState(0)
    const [balance, setBalance] = React.useState(0)
    const [user, setUser] = useState<ItemUser>({} as ItemUser);
    const [balanceCasino, setBalanceCasino] = React.useState(0)
    const [balance45, setBalance45] = React.useState(0)
    const [PAC, setPAC] = useState<any>();
    const [polls, setPolls] = useState<ItemPoll[]>();
    const [pollDiscard, setPollDiscard] = useState<ItemPoll>();

    const { navigate } = useRouter();


    const [weatherConnectionStatus, setWeatherConnectionStatus] = useState(true);
    const [connected, setConnected] = useState(false);
    const [locadingContent, setLoadingContent] = useState(false);
    const [isToday, setIsToday] = useState(true);
    const [devices, setDevices] = useState([]);
    const [urlCamera, setUrlCamera] = useState("");
    const [cameraId, setCameraId] = useState("P07");
    const [realtimeData, setRealtimeData] = useState<AmbientData>();
    const [checks, setChecks] = useState<ItemCheck[]>([]);
    const [applicationKey] = useState("8f6e5eac30d04eed8ee8606b03ed5d080e5db8c41fd24136a9aa18904457cc4a");
    const [apiKeys] = useState(["759e70cd3b6b4d93b4b3ef5b053b2a3b5879c8825bd14601be6060709b9d2df9"]);
    const [apiKey] = useState("759e70cd3b6b4d93b4b3ef5b053b2a3b5879c8825bd14601be6060709b9d2df9");
    const [weather, setWeather] = useState("offline");


    useEffect(() => {
        if (!applicationKey || !apiKeys || apiKeys.length === 0) {
            console.error('Missing keys');
            return;
        }

        const endpoint = `https://rt.ambientweather.net/?api=1&applicationKey=${applicationKey}`;
        // Optional config
        const socket = io(endpoint, {
            transports: ['websocket'],  // try websocket first
            timeout: 10000,

            // other options as needed (timeout, reconnection etc.)
        });

        socket.on('connect', () => {
            setWeather("online");
            setConnected(true);

            // Send the subscribe command
            let apk = {
                command: 'subscribe',
                apiKeys: apiKeys
            }
            socket.emit('subscribe', { apiKeys });
        });

        socket.on('disconnect', (reason: any) => {
            setWeather("offline");
            setTimeout(function () {
                setConnected(false);
            }, 10000);
        });

        socket.on('subscribed', (data: any) => {

            if (data && data.devices && data.devices.length > 0) {
                setRealtimeData(data.devices[0].lastData);
            }
            // data.devices has info about which devices subscribed
            setDevices(data.devices || []);
        });

        socket.on('data', (data: any) => {
            setRealtimeData(data);

        });

        socket.on('connect_error', (err: any) => {
            setWeather("error")

        });

        // Cleanup on unmount
        return () => {
            if (socket) {
                socket.emit('command', { command: 'unsubscribe', apiKeys });
                socket.disconnect();
            }
        };
    }, [applicationKey, apiKeys]);
    useEffect(() => {
        console.log(`Weather status changed: ${weather}`);
        const cnx = weather !== "error";
        setWeatherConnectionStatus(cnx);
    }, [weather]);

    const handleMarkRead = async (idMessage: number) => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/?session4`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/login/data',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({
                    idMessage: idMessage
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataTmp = await response.json();
            if (dataTmp.code == 0) {


                if (dataTmp.notifications) {
                    setNotifications(dataTmp.notifications.map((n: any) => ({
                        ...n,
                        loading: false
                    })));
                }
                if (dataTmp.UF && dataTmp.USD) {
                    const updatedData = { ...data, UF: Number(dataTmp.UF), USD: Number(dataTmp.USD) };
                    setData(updatedData);
                }
                if (dataTmp.counters) {
                    const updatedData = { ...data, counters: dataTmp.counters };
                    setData(updatedData);
                }

            }
        } catch (error: any) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const handleDiscardPoll = async (p: ItemPoll) => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/?session4`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/polls/discard',
                    'JWT': getCookie("JWT"),
                },
                body: JSON.stringify({
                    idPoll: p.idPoll
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataTmp = await response.json();
            if (dataTmp.code == 0) {
                setPollDiscard(undefined);
                if (dataTmp.polls) {
                    setPolls(dataTmp.polls);
                }
            }
        } catch (error: any) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    const handlePAC = async () => {
        try {

            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/movements/pac/charges',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();

            if (dataWeb.code === 0) {

            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };
    const handleRefresh = async () => {
        try {

            setLoadingContent(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/home',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    movements: true,
                    hash: "home"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();

            if (dataWeb.code === 0) {
                storeJWT(dataWeb)
                setPAC(dataWeb.pac)
                setFuelAVGASInternal(dataWeb.fuelAVGASInternal)
                setFuelAVGASExternal(dataWeb.fuelAVGASExternal)
                setFuelJP1Internal(dataWeb.fuelJP1Internal)
                setFuelJP1External(dataWeb.fuelJP1External)
                setCounters(dataWeb.counters)
                setBalance(dataWeb.balance)
                setBalance45(dataWeb.balance45)
                setBalanceCasino(dataWeb.balanceCasino)

                if (dataWeb && dataWeb.polls) {
                    setPolls(dataWeb.polls)
                } else {
                    setPolls(undefined)
                }
                if (dataWeb && dataWeb.time) {
                    setTimeFCCV(dataWeb.time.fccv)
                    setTimeH0(dataWeb.time.zero)

                }
                if (dataWeb && dataWeb.movements) {
                    setMovements(dataWeb.movements)
                }
                if (dataWeb && dataWeb.user) {
                    setUser(dataWeb.user)
                }
                if (dataWeb && dataWeb.checks) {
                    setChecks(dataWeb.checks)
                }
                let tShifts: any = [];
                const processedIds = new Set<string | number>();
                let isTodayShift = true;
                if (dataWeb.shift && dataWeb.shift.length > 0) {
                    isTodayShift = dataWeb.shift[0].dateShift === format(new Date(), 'dd-MM-yyyy');
                }
                if (dataWeb.bookingsShift && dataWeb.bookingsShift.length > 0) {
                    isTodayShift = dataWeb.bookingsShift[0].dateStart === format(new Date(), 'dd-MM-yyyy');
                }
                setIsToday(isTodayShift);

                if (dataWeb.shift) {
                    const localShifts: any[] = dataWeb.shift;
                    localShifts.forEach((shift: any) => {
                        // Add ID to the Set
                        processedIds.add(shift.idUser);

                        tShifts.push({
                            label: shift.shift === "DIR" ? shift.idUserMercenary == 0 ? "Director" : <>Director<Icon path={mdiPirate} size={0.7} /></> : `Remolcador`,
                            value: <PopOverContact idUser={shift.idUserMercenary == 0 ? shift.idUser : shift.idUserMercenary} />,
                            info: shift.shift === "DIR" ? "" : shift.shift

                        });
                    });
                }

                if (dataWeb.bookingsShift) {
                    const localShifts: any[] = dataWeb.bookingsShift;
                    localShifts.forEach((booking: any) => {
                        // 2. Only push if the ID is NOT in the Set
                        if (!processedIds.has(booking.idUser)) {
                            tShifts.push({
                                label: "Remolcador",
                                info: `${booking.timeStart} - ${booking.timeEnd}`,
                                value: <PopOverContact idUser={booking.idUser} />
                            });
                        }
                    });
                }

                setShift(tShifts);
                let tShiftsNew: any = [];


                if (dataWeb.shift) {
                    const localShifts: any[] = dataWeb.shift;
                    localShifts.forEach((shift: any) => {
                        // Add ID to the Set
                        processedIds.add(shift.idUser);

                        tShiftsNew.push({
                            label: shift.shift === "DIR" ? shift.idUserMercenary == 0 ? "Director" : <>Director<Icon path={mdiPirate} size={0.7} /></> : `Remolcador`,
                            value: <PopOverContact hideUser triggerType='text' content={getUser(shift.idUserMercenary == 0 ? shift.idUser : shift.idUserMercenary, data)?.displayName} idUser={shift.idUserMercenary == 0 ? shift.idUser : shift.idUserMercenary} />,
                            info: shift.shift === "DIR" ? "" : shift.shift

                        });
                    });
                }

                if (dataWeb.bookingsShift) {
                    const localShifts: any[] = dataWeb.bookingsShift;
                    localShifts.forEach((booking: any) => {
                        // 2. Only push if the ID is NOT in the Set
                        if (!processedIds.has(booking.idUser)) {
                            tShiftsNew.push({
                                label: "Remolcador",
                                info: `${booking.timeStart} - ${booking.timeEnd}`,
                                value: <PopOverContact hideUser triggerType='text' content={booking.displayName} idUser={booking.idUser} />
                            });
                        }
                    });
                }

                setShiftNew(tShiftsNew);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoadingContent(false);

        }
    };
    useEffect(() => {
        handleRefresh();
    }, []);
    useEffect(() => {
        handleNotifications();
    }, [])
    function showNotification() {

        Notification.requestPermission().then((result) => {
            if (result === "granted") {
                navigator.serviceWorker.ready.then((registration) => {
                    registration.showNotification("Vibration Sample", {
                        body: "Buzz! Buzz!",
                        icon: "../images/touch/chrome-touch-icon-192x192.png",
                        tag: "vibration-sample",
                    }).then(() => {
                    }).catch((e: any) => {
                    });
                });
            }
        });
    }
    const handleNotifications = async () => {
    };
    const handleNotification = async () => {
        //showNotification();
        //return;
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/message/send',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleCameraLink = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/public.aspx`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/public/cameras/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    camera: cameraId
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.cameras) {
                setUrlCamera(data.cameras[0]?.url || "")
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (cameraId !== "") {
            handleCameraLink()
        }
    }, [cameraId]);
    useEffect(() => {
        addNotification(data.status, "error", setData);
        let msgs: FlashbarProps.MessageDefinition[] = []

        notifications.map((notification, index) => {
            if (notification.type === "CHECK") {
                let message: FlashbarProps.MessageDefinition = {
                    type: "warning",
                    content: notification.notification,
                    id: 'pending-instruction'
                }
                msgs.push(message)
            }
            if (notification.type === "ACCOUNT") {
                let message: FlashbarProps.MessageDefinition = {
                    type: "error",
                    content: notification.notification,
                    id: 'pending-instruction1q'
                }
                msgs.push(message)
            }
        })
    }, [notifications]);

    const PAX_GROUP_ID = 2209059;
    const SHIFTS_GROUP_ID = 135036;

    const isPaxOrShifts = (user: { groups: ItemsGroups[] }) => {
        // Check if the user's groups array contains either ID
        try {
            return user.groups.some(
                (group: ItemsGroups) => group.idGroup === PAX_GROUP_ID || group.idGroup === SHIFTS_GROUP_ID
            );
        } catch (e) {
            console.error("Error checking user groups:", e);
            return false;
        }
    }

    const targetRef = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);
    const [vpWidth, setVpWidth] = useState(0);
    const [timeUTC, setTimeUTC] = useState("N/A");
    const [timeFCCV, setTimeFCCV] = useState("N/A");
    const [timeH0, setTimeH0] = useState("N/A");
    const [phone, setPhone] = useState("");
    useEffect(() => {
        setTimes();
        setInterval(() => {
            setTimes();
        }, 10000);
    }, []);
    function setTimes() {
        const now = new Date();
        const formattedUTC = format(now, 'HH:mm', { in: tz('UTC') })
        setTimeUTC(formattedUTC);
    }

    useLayoutEffect(() => {
        if (!targetRef.current) return;

        const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const measuredWidth = entry.contentRect.width;

                // OPTION A: Follow container exactly


                setVpWidth(measuredWidth);
                // OPTION B: Follow container but cap it at 300px
                setWidth(Math.min(measuredWidth, 200));
            }
        });

        observer.observe(targetRef.current);
        return () => observer.disconnect();
    }, []);
    const certDate = user != undefined && user?.studentCertification ? parse(user?.studentCertification, "dd-MM-yyyy", new Date()) : "";
    const isValidDate = isValid(certDate);

    // 2. Calculate one month before the certification date
    const oneMonthBeforeCert = subMonths(certDate, 1);

    // 3. Check if today is on or after (closer to/past) that one-month threshold
    const isWithinOneMonthOrPast = isValidDate && isAfter(new Date(), oneMonthBeforeCert);


    const semester = getMonth(new Date()) < 4 ?
        `primer semestre ${format(addYears(new Date(), 0), 'yyyy')}` : getMonth(new Date()) < 9 ?

            `segundo semestre ${format(new Date(), 'yyyy')}` : `primer semestre ${format(new Date(), 'yyyy')}`;


    return (

        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={

                <div ref={targetRef}>
                    <SpaceBetween size="s" direction="vertical">
                        <Header key="header-greeting" variant="h1">
                            Hola {displayName}
                        </Header>


                        {user?.studentCertification && user.studentCertification !== "" && isValidDate && isWithinOneMonthOrPast && (
                            <Alert
                                action={<Button onClick={() => (window.location.hash = "#user/student")}>Subir certificado</Button>}
                                type='warning' header="Estimado socio">De acuerdo a nuestros registros usted tiene cargos asociados a la condición de <b>estudiante</b>. El vencimiento de justificación de este beneficio es el <b>{user.studentCertification}</b>. Para continuar con este beneficio, usted debe presentar su certificado de alumno regular emitido por su establecimiento educacional para el <em>{semester}</em></Alert>
                        )}



                        {vpWidth > 0 && (

                            <ExpandableSection headerText={`Meteo SCLC`} headerActions={weather === "offline" ? <Spinner size="normal" /> :
                                weatherConnectionStatus ? null : <Icon path={mdiCloudOffOutline} size={0.7} />

                            } variant="inline" defaultExpanded={false}>
                                {vpWidth > 745 && (
                                    <SpaceBetween direction="vertical" size="xs">
                                        <div style={{ maxWidth: 745 }}>
                                            <Container disableContentPaddings>
                                                <SpaceBetween direction="horizontal" size="l" alignItems="center">

                                                    <FormField label="&nbsp;">
                                                        &nbsp;&nbsp;<Icon path={mdiWeatherSunsetDown} size={2.5} />
                                                    </FormField>

                                                    <FormField label="Hora FCCV">
                                                        <Box variant="awsui-value-large">{timeFCCV}</Box>
                                                    </FormField>

                                                    <FormField label="Hora zero">
                                                        <Box variant="awsui-value-large">{timeH0}</Box>
                                                    </FormField>

                                                    <FormField label="Hora UTC">
                                                        <Box variant="awsui-value-large">{timeUTC}</Box>
                                                    </FormField>

                                                </SpaceBetween>

                                            </Container>
                                        </div>
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <Container>
                                                <FormField label={<>Viento <Icon path={mdiWeatherWindy} size={1} /></>}>
                                                    <GaugeWind size={width} data={realtimeData || {}} />
                                                </FormField>
                                            </Container>
                                            <Container>
                                                <FormField label={<>Temperatura <Icon path={mdiThermometer} size={1} /></>}>
                                                    <GaugeTemp size={width} data={realtimeData || {}} />
                                                </FormField>
                                            </Container>
                                            <Container>
                                                <FormField label={<>Presión <Icon path={mdiArrowCollapseVertical} size={1} /></>}>
                                                    <GaugePressure size={width} data={realtimeData || {}} />
                                                </FormField>
                                            </Container>
                                        </SpaceBetween>
                                    </SpaceBetween>

                                )}
                                {vpWidth <= 745 && (
                                    <Tabs

                                        onChange={(e) => {
                                            if (e.detail.activeTabId === 'tab-camera') {
                                                //setUrlCamera(realtimeData?.imageurl || "");
                                            }
                                        }}
                                        tabs={[
                                            {
                                                id: 'tab-weather-gauges5', label: <Icon path={mdiWeatherSunsetDown} size={1} />, content:

                                                    <SpaceBetween direction="vertical" size="l" alignItems="center">
                                                        <SpaceBetween direction="horizontal" size="l" alignItems="center">

                                                            <FormField label="Hora FCCV">
                                                                <Box variant="awsui-value-large">{timeFCCV}</Box>
                                                            </FormField>
                                                            <FormField label="Hora zero">
                                                                <Box variant="awsui-value-large">{timeH0}</Box>
                                                            </FormField>
                                                        </SpaceBetween>

                                                        <FormField label="Hora UTC">
                                                            <Box variant="awsui-value-large">{timeUTC}</Box>
                                                        </FormField>
                                                    </SpaceBetween>
                                            },
                                            {
                                                id: 'tab-weather-gauges2', label: <Icon path={mdiWeatherWindy} size={1} />, content:
                                                    <Form header={<Header variant="h2">Viento</Header>}>
                                                        <GaugeWind size={width} data={realtimeData || {}} />
                                                    </Form>
                                            },
                                            {
                                                id: 'tab-weather-gauges', label: <Icon path={mdiThermometer} size={1} />, content:
                                                    <Form header={<Header variant="h2">Temperatura</Header>}>
                                                        <GaugeTemp size={width} data={realtimeData || {}} />
                                                    </Form>
                                            },
                                            {
                                                id: 'tab-weather-gauges1', label: <Icon path={mdiArrowCollapseVertical} size={1} />, content:
                                                    <Form header={<Header variant="h2">Presión</Header>}>
                                                        <GaugePressure size={width} data={realtimeData || {}} />
                                                    </Form>
                                            },
                                            {
                                                id: 'tab-camera', label: <Icon path={mdiCctv} size={1} />, content:
                                                    <Form header={<Header variant="h2">
                                                        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                                            Cámaras

                                                            <SegmentedControl
                                                                selectedId={cameraId}
                                                                onChange={({ detail }) =>
                                                                    setCameraId(detail.selectedId.toString())
                                                                }
                                                                options={[
                                                                    { text: "Pista 26", id: "P25" },
                                                                    { text: "Pista 08", id: "P07" },
                                                                ]} />
                                                        </SpaceBetween>
                                                    </Header>}>
                                                        <img src={urlCamera} alt="Camera Snapshot" style={{ width: '100%', maxWidth: '800px', height: 'auto', borderRadius: '8px' }} />
                                                    </Form>
                                            },
                                        ]}
                                    />
                                )}
                            </ExpandableSection>
                        )}
                        {locadingContent && (
                            <Box textAlign="center" padding="s">
                                <Spinner size="large" />
                            </Box>
                        )}

                        {!!polls &&
                            polls
                                .filter((poll: ItemPoll) => poll.isCompleteUser === 0)
                                .map((poll: ItemPoll) => (

                                    <Container
                                        footer={
                                            <Box float="right">
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    {poll.publicResults === 1 ? <Button href={`#members/etc/polls.answers?id=${poll.idPoll}`}>Ver inscritos {poll.totalUsers > 0 ? `(${poll.totalUsers})` : ""}</Button> : null}

                                                    <Button variant="primary" disabled={!(poll.hasStarted === 1 && poll.hasEnded === 0)} href={`#members/etc/polls?id=${poll.idPoll}`}>{poll.hasStarted === 1 && poll.hasEnded === 0 ? "Inscribirme" : "Finalizada"}</Button>


                                                </SpaceBetween>
                                            </Box>

                                        }
                                        header={<Header variant="h2">{poll.poll}</Header>}>
                                        {poll.description.length > 300 ? poll.description.substring(0, 300) + "..." : poll.description}
                                        <Link onClick={() => {
                                            setPollDiscard(poll)
                                        }}>Descartar</Link>
                                    </Container>
                                ))}
                        {shift.length > 0 && (
                            <Container header={<Header variant="h2"
                                counter={!isToday ? <>Mañana <em>{format(addDays(new Date(), 1), "dd MMM", { locale: es })}</em></> : null}
                            >Personal de turno</Header>}>
                                <KeyValuePairs
                                    key="shift-kvp"
                                    columns={isMobileDevice() ? 1 : 3}
                                    items={shiftNew}
                                />
                            </Container>
                        )}


                        {notifications && notifications.length > 0 && (
                            <Alert key="notifications-alert" type="info">
                                {notifications
                                    .filter(notification => notification.title && notification.title !== "").map((notification, index) => (
                                        <FormField label={notification.title}
                                            info={
                                                notification.idMessage > 0 && (
                                                    <Link onClick={() => {
                                                        handleMarkRead(notification.idMessage);
                                                    }}>Descartar</Link>
                                                )
                                            }
                                        >
                                            {notification.href ? (
                                                <>
                                                    {notification.notification}{" "}
                                                    <Link href={notification.href}>
                                                        <Icon path={mdiCheckboxMultipleBlankOutline} size={0.75} />
                                                    </Link>
                                                </>
                                            ) : (
                                                notification.notification
                                            )}

                                        </FormField>
                                    ))}
                            </Alert>
                        )}

                        {!!balance !== null && (
                            <Container key="balance-container">
                                <Header variant="h2">Saldos</Header>
                                <KeyValuePairs
                                    columns={isMobileDevice() ? 1 : 3}
                                    minColumnWidth={130}
                                    items={[
                                        {
                                            label: "Cuenta Club", value:

                                                <Box variant="awsui-value-large">{formatCurrency(balance, "CLP")}</Box>,
                                        },
                                        { label: "Cuenta Casino", value: <Box variant="awsui-value-large">{formatCurrency(balanceCasino, "CLP")}</Box> }
                                    ]}
                                />
                            </Container>
                        )}

                        {!!checks && checks !== null && checks.length > 0 && (
                            <Container key="checks-container">
                                <Header variant="h2" description={"Chequeos pendientes o recientemente finalizados"}>Chequeos</Header>
                                <Spacer height={10} />
                                <Divider />
                                <Spacer height={10} />
                                <SpaceBetween direction="horizontal" size="l">
                                    {checks.map((check, index) => (
                                        <StepsCheck key={"check-" + index} check={check} />
                                    ))}

                                </SpaceBetween>
                            </Container>
                        )}

                        {Boolean(fuelAVGASExternal) && (
                            <Container>
                                <Header variant="h2">
                                    Combustible
                                </Header>
                                <KeyValuePairs
                                    key={"fuel"}
                                    columns={4}
                                    minColumnWidth={160}
                                    items={[
                                        {
                                            label: 'AVGAS',
                                            // Use a fallback of 0 or a string so toFixed(0) doesn't crash if data is null
                                            value: formatCurrency(fuelAVGASInternal, "CLP")
                                        },
                                        {
                                            label: 'AVGAS Externo',
                                            value: formatCurrency(fuelAVGASExternal, "CLP")
                                        },
                                        {
                                            label: 'JP1',
                                            value: formatCurrency(fuelJP1Internal, "CLP")
                                        },
                                        {
                                            label: 'JP1 Externo',
                                            value: formatCurrency(fuelJP1External, "CLP")
                                        },
                                    ]}
                                />
                            </Container>
                        )}
                        <Confirm show={!!pollDiscard} action={'Descartar'} warning={'Su registro será descartado de la página inicial. Podra visualizarlo o modificar su registro directamente desde Socios>Otros>Inscripciones'} onDismiss={() => setPollDiscard(undefined)} onConfirm={() => {
                            handleDiscardPoll(pollDiscard);
                        }} />
                    </SpaceBetween>
                </div>

            }

        />

    );
};

function m2k(deg: any) {
    return (deg * 1.94384).toFixed(1);
}
function f2c(deg: any) {
    return ((deg - 32) * 5 / 9).toFixed(1)
}
function windDirectionToCompass(deg: any) {
    if (deg == null || isNaN(deg)) return "";

    // 16-point compass rose
    const directions = [
        "N", "NNE", "NE", "ENE",
        "E", "ESE", "SE", "SSE",
        "S", "SSW", "SW", "WSW",
        "W", "WNW", "NW", "NNW"
    ];

    // Divide circle into 16 sectors (22.5° each)
    const index = Math.round(deg / 22.5) % 16;
    return directions[index];
}
function urlBase64ToUint8Array(base64String: string) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

